import regImg from '../assets/image2.png';
import logoImg from '../logo.svg';
import './Register.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CreateAccount } from '../apiconfig/authService';
// import { useScrollToTop } from '@react-navigation/native';
// import {Icon} from 'react-icons-kit';
// import {eyeOff} from 'react-icons-kit/feather/eyeOff';
// import {eye} from 'react-icons-kit/feather/eye';
// import { Link } from 'react-router-dom';

// const [password, setPassword] = useState("");
// const [type, setType] = useState('password');
// const [icon, setIcon] = useState(eyeOff);

// const handleToggle = () => {
//     if (type==='password'){
//        setIcon(eye);
//        setType('text')
//     } else {
//        setIcon(eyeOff)
//        setType('password')
//     }
//  }

const Register = () => {

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    // const [addressLine, setAddressLine] = useState('');
    // const [city, setCity] = useState('');
    // const [state, setState] = useState('');
    // const [country, setCountry] = useState('');
    // const [pinCode, setPinCode] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isMessageRed, setIsMessageRed] = useState(false);
    // const [cityList, setCityList] = useState([]);
    // const [stateList, setStateList] = useState([]);
    // const [countryList, setCountryList] = useState([]);
    // const [filteredCityList, setFilteredCityList] = useState([]);
    // const [filteredStateList, setFilteredStateList] = useState([]);

    // useEffect(() => {
    //     (async () => {
    //         try{
    //             const citiesResponse = await axios.get('https://scrapbackend.pikeazy.in/customer/cities');
    //             setCityList(citiesResponse.data.cities);
    //             setFilteredCityList(citiesResponse.data.cities);
    //             const statesResponse = await axios.get('https://scrapbackend.pikeazy.in/customer/states');
    //             setStateList(statesResponse.data.states);
    //             setFilteredStateList(statesResponse.data.states);
    //             const countriesResponse = await axios.get('https://scrapbackend.pikeazy.in/customer/countries');
    //             setCountryList(countriesResponse.data.countries);
    //         }catch(error){
    //             setMessage('An error occurred. Please try again later.');
    //         }
    //     })();
    //     }, []);

    // useEffect(()=>{
    //     if(country){
    //         const countryId = countryList.find(item => item.country===country).countryid;
    //         setFilteredStateList(stateList.filter(item => item.countryid===countryId));
    //     }
    // }, [country]);

    // useEffect(()=>{
    //     if(state){
    //         const stateId = stateList.find(item => item.state===state).stateid;
    //         setFilteredCityList(cityList.filter(item => item.stateid===stateId));
    //     }
    // }, [state]);

    const validateForm = () => {
        if (firstName === '')
            throw new Error('First Name is required.');
        if (lastName === '')
            throw new Error('Last Name is required.');
        if (email === '')
            throw new Error('Email is required.');
        if (!email.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/))
            throw new Error('Invalid email address.');
        if (phoneNumber === '')
            throw new Error('Phone number is required.');
        if (!phoneNumber.match(/^\d{10}$/))
            throw new Error("Invalid phone number. Please enter a 10-digit phone number.");
        if (password === '')
            throw new Error('Password is required.');
        if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/))
            throw new Error("Invalid password. It must contain at least one lowercase letter, one uppercase letter, one digit, one special character, and be at least 8 characters long.");
        // if(addressLine==='')
        //     throw new Error("Address line is required.");
        // if(city==='')
        //     throw new Error("City is required.");
        // if(state==='')
        //     throw new Error("State is required.");
        // if(country==='')
        //     throw new Error("Country is required.");
        // if(pinCode==='')
        //     throw new Error("Pin code is required.");
        // if(!pinCode.match(/^\d{6}$/))
        // throw new Error('Invalid pin code. Enter a valid 6-digit pin code.');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            validateForm();
        } catch (error) {
            setIsMessageRed(true);
            setMessage(error.message);
            window.scrollTo(0, 0);
            return;
        }


        let response;
        try {
            response = await CreateAccount(
                {
                    firstname: firstName,
                    lastname: lastName,
                    customerphone: phoneNumber,
                    // addressline: addressLine,
                    // city,
                    // state,
                    // country,
                    // pincode: pinCode,
                    emailid: email,
                    password: password
                });
            if (response.status === 201) {
                setIsMessageRed(false);
                setMessage(response.data.message);
                window.scrollTo(0, 0);
            }
        } catch (err) {
            if ((err.response && err.response.data) && err.response.data.error) {
                setIsMessageRed(true);
                setMessage(err.response.data.error);
                window.scrollTo(0, 0);
            } else {
                setIsMessageRed(true);
                setMessage('An error occurred. Please try again later.');
                window.scrollTo(0, 0);
            }
        }
    };


    return (
        <div className="regPage container-fluid">
            <div className="row bg-light">
                <div className="col-lg-8 p-5">
                    <img src={regImg} className="loginImg d-block mx-auto img-fluid" width="700" alt=" Dummy" />
                </div>
                <div className="col-lg-4 bg-white p-5 d-flex align-items-center">
                    <div className="loginCont w-100">
                        <div className="logo mb-4">
                            <img src={logoImg} className="logoImg img-fluid" width="80" alt="Logo" />
                        </div>
                        <h3 className="text-primary mb-4">Sign up with <span>Dashboard</span></h3>
                        <p>Make your app management easy and fun!</p>

                        {message && <div style={{ color: isMessageRed ? 'red' : 'black' }} className="alert alert-primary" role="alert">{message}</div>}

                        <form onSubmit={handleSubmit} className="RegForm">
                            <div className="form-floating mb-4">
                                <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} className="form-control" id="floatingInput" />
                                <label htmlFor="floatingInput">First Name</label>
                            </div>
                            <div className="form-floating mb-4">
                                <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} className="form-control" id="floatingInput" />
                                <label htmlFor="floatingInput">Last Name</ label>
                            </div>
                            <div className="form-floating mb-4">
                                <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" id="floatingInput" />
                                <label htmlFor="floatingInput">Email Address</label>
                            </div>
                            <div className="form-floating mb-4">
                                <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} className="form-control" id="floatingInput" placeholder="name@example.com" />
                                <label htmlFor="floatingInput">Phone Number</label>
                            </div>
                            <div className="form-floating mb-4">
                                <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="form-control" id="floatingPassword" placeholder="Password" />
                                <label htmlFor="floatingInput">Password</label>
                            </div>
                            {/* <div className="form-floating mb-4">
                                <input type="text" value={addressLine} onChange={(e) => setAddressLine(e.target.value)} className="form-control" id="floatingInput" placeholder="name@example.com" />
                                <label htmlFor="floatingInput">Address Line</label>
                            </div>
                            <div className="form-floating mb-4">
                                <select className="form-select" onChange={(e) => setCity(e.target.value)} value={city}>
                                    <option value="">Select a city</option>
                                    { filteredCityList.map((city) => (
                                        <option value={city.city}>
                                            {city.city}
                                        </option>)
                                    )}
                                </select>
                                <label htmlFor="floatingInput">City</label>
                            </div>
                            <div className="form-floating mb-4">
                                <select className="form-select" onChange={(e) => setState(e.target.value)} value={state}>
                                    <option value="">Select a state</option>
                                    {filteredStateList.map((state) => (
                                        <option value={state.state}>
                                            {state.state}
                                        </option>)
                                    )}
                                </select>
                                <label htmlFor="floatingInput">State</label>
                            </div>
                            <div className="form-floating mb-4">
                                <select className="form-select" onChange={(e) => setCountry(e.target.value)} value={country}>
                                    <option value="">Select a country</option>
                                    {countryList.map((country) => (
                                        <option value={country.country}>
                                            {country.country}
                                        </option>)
                                    )}
                                </select>
                                <label htmlFor="floatingInput">Country</label>
                            </div>
                            <div className="form-floating mb-4">
                                <input type="text" value={pinCode} onChange={(e) => setPinCode(e.target.value)} className="form-control" id="floatingInput" placeholder="name@example.com" />
                                <label htmlFor="floatingInput">Pin Code</label>
                            </div> */}
                            <div className="form-check mb-4">
                                <input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
                                <label className="form-check-label" htmlFor="flexCheckChecked">
                                    I agree to
                                    &nbsp; <a href="/" className="fw-bold text-primary text-decoration-none">privacy policy & terms</a>
                                </label>
                            </div>
                            <div className="buttons mb-4">
                                <button type="submit" className="btn btn-primary shadow-sm text-shadow btn-lg w-100 text-uppercase">Sign Up</button>
                            </div>
                            <div className="regis mb-4 text-center">
                                Already have an account? <a href="/" className="fw-bold text-primary text-decoration-none">Sign in instead</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Register;